module.exports = __webpack_public_path__ + "static/media/product-detail-layout-button-one.eb0fcb4e.png";